
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/[slug]",
      function () {
        return require("private-next-pages/reviews/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/[slug]"])
      });
    }
  